import { oneLineString } from "./Text";


export const oneLineClass = (classNames) => ({className: oneLineString(classNames)})